var React = require('react');

function JsdIconReact (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"x1":"38.04%","y1":"6.64%","x2":"59.86%","y2":"63.78%","id":"a"},[React.createElement("stop",{"stopColor":"#344563","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#5E6C84","offset":"100%","key":1})])),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M-9-6h32v32H-9z","key":0}),React.createElement("g",{"fillRule":"nonzero","key":1},[React.createElement("path",{"d":"M8.93 7.56l5.2.02a.81.81 0 0 1 .65 1.3L7.09 19.14A5.46 5.46 0 0 1 6 11.5l2.94-3.94z","fill":"url(#a)","key":0}),React.createElement("path",{"d":"M5.98 11.5l-5.17-.04a.81.81 0 0 1-.65-1.3L7.77 0a5.46 5.46 0 0 1 1.11 7.64l-2.9 3.86z","fill":"#5E6C84","key":1})])])]);
}

JsdIconReact.defaultProps = {"width":"15","height":"20"};

module.exports = JsdIconReact;

JsdIconReact.default = JsdIconReact;
